<template>
  <div class="home-bottom-bar">
    <div class="tab-group">
      <div>
        <div class="icon">
          <img src="../../assets/index/img.png" />
        </div>
        <div @click="curtab = 1" class="text">图形</div>
        <ul v-show="curtab == 1">
          <li @click="changeBar">柱状图</li>
          <li @click="changeLine">折线图</li>
        </ul>
      </div>
      <div>
        <div class="icon">
          <img src="../../assets/header_menu/time.png" />
        </div>
        <div @click="curtab = 2" class="text">时段</div>
        <ul v-show="curtab == 2">
          <li @click="curtab = 0">本年</li>
          <li @click="curtab = 0">前推</li>
        </ul>
      </div>
      <div>
        <div class="icon">
          <img src="../../assets/index/content.png" />
        </div>
        <div @click="curtab = 3" class="text">显示内容</div>
        <ul v-show="curtab == 3">
          <li @click="curtab = 0">人次</li>
          <li @click="curtab = 0">人数</li>
        </ul>
      </div>
    </div>
    <div
      :class="className"
      :id="id"
      :style="{ height: height, width: width }"
    />
  </div>
</template>

<script>
import resize from "./mixins/resize";

export default {
  name: "HomeBottomBar",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "HomeBottomBar"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "170px"
    },
    colorList: {
      type: Array,
      default() {
        return ["#3972ff", "#38b5f3", "#06c5a1"];
      }
    },
    chartData: {
      type: Object
    }
  },
  data() {
    return {
      chart: null,
      option: null,
      curtab: 0
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      let series = [];
      for (let i = 0; i < this.chartData.data.length; i++) {
        let temp = {
          name: this.chartData.data[i].legend,
          type: "bar",
          data: this.chartData.data[i].valueList,
          markLine: {
            symbol: "none",
            lineStyle: {
              normal: {
                opacity: 0.7
              }
            },
            data: [
              {
                yAxis: Math.round(this.getAvg(this.chartData.data[i].valueList))
              }
            ]
          },
          itemStyle: {
            normal: {
              color: this.colorList[i]
            }
          },
          barWidth: 10
        };
        series.push(temp);
      }
      this.option = {
        grid: {
          top: "8%",
          bottom: "0%",
          left: 20,
          right: "5.5%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          // triggerOn: "none",
          confine: true,
          textStyle: {
            color: "#cbeeff"
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        toolbox: {
          // feature: {
          //   magicType: { show: true, type: ['line', 'bar'] },
          //   restore: { show: true }
          // }
        },
        legend: {
          icon: "rect",
          left: "9%",
          top: "0%",
          itemGap: 12,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 14,
            color: "#cbeeff"
          }
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData.nameList,
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "#132847"
              }
            },
            axisLabel: {
              color: "#cbeeff"
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            axisLabel: {
              color: "#cbeeff",
              formatter: "{value}"
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: series
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option);
      this.chart.on("click", function(params) {
        console.log(params);
        // this.chart.dispatchAction({
        //   type: "showTip",
        //   seriesIndex: params.seriesIndex,
        //   dataIndex: params.dataIndex
        // });
      });
    },
    changeBar() {
      this.curtab = 0;
      for (let i = 0; i < this.option.series.length; i++) {
        this.option.series[i].type = "bar";
      }
      this.chart.setOption(this.option);
    },
    changeLine() {
      this.curtab = 0;
      for (let i = 0; i < this.option.series.length; i++) {
        this.option.series[i].type = "line";
      }
      this.chart.setOption(this.option);
    },
    getAvg(arr) {
      var total = 0;
      for (let i = 0; i < arr.length; i++) {
        total += arr[i];
      }
      var avg = total / arr.length;
      return avg;
    }
  }
};
</script>
<style scoped lang="less">
.home-bottom-bar {
  width: 100%;
  height: 100%;
  position: relative;
  .tab-group {
    height: 0.3rem;
    line-height: 0.3rem;
    position: absolute;
    z-index: 999;
    right: 0.15rem;
    top: 0;
    color: @base-text-color;
    > div {
      float: left;
      padding-right: 0.15rem;
      position: relative;
      > div {
        float: left;
      }
      .icon {
        width: 0.3rem;
        height: 0.3rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .text {
        cursor: pointer;
      }
      ul {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0.3rem;
        li {
          width: 100%;
          height: 0.22rem;
          line-height: 0.22rem;
          border: 1px solid #0c6398;
          background: rgba(0, 183, 247, 0.2);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
